import React from 'react';
import './Question.scss';
import minus from "../../assets/img/minus.svg";
import plus from  "../../assets/img/plus.svg";
import { useState } from 'react';

function Question({data}) {
    const [open,setOpen] = useState(false);
    const openAnswer = () => {
        setOpen(!open);
      }
    const [changeImage,setChangeImage]=useState(plus)  
  return (
    <div className="question-main">
        <div className="question-wrapper">
            <div className="question-content">
                <div className="question-item">
                    <div className="question">
                        {data.question}
                    </div>
                    <div className="question-img" onClick={()=>{
                        openAnswer();
                        changeImage === plus ? setChangeImage(minus): setChangeImage(plus);
                    }}>
                        <img src={changeImage} alt="plus" />
                    </div>
                </div>
                <div className={`${"answer"} ${open? 'answer-active' : ''}`}>
                    {data.answer}
                </div>
            </div>    
        </div>
    </div>
  );
}

export default Question;